import {
  FILTER_VIEW_TYPE,
  type UserCommunicationFilter,
} from './filter/useFilterUserCommunications';
import { useUserCommunicationsStore } from '../../store';

export const useIsAwaitingFreshData = (
  filterBy: UserCommunicationFilter,
): boolean => {
  const syncedViewTypes = useUserCommunicationsStore(
    (state) => state.syncedViewTypes,
  );
  const viewType = FILTER_VIEW_TYPE[filterBy];

  return viewType !== undefined && !syncedViewTypes.includes(viewType);
};
